import { ToastContainer } from 'react-toast/src/ToastContainer'
import { ToastProvider as ToastProviderOriginal } from 'react-toast/src/ToastProvider'
import { ToastProps } from 'react-toast/src/types'
import { css } from '@emotion/react'

import CheckmarkIcon from '../icons/CheckmarkIcon'
import CloseIcon from '../icons/CloseIcon'
import WarningIcon from '../icons/WarningIcon'
import Colors from '../theme/Colors'

export { useToasts } from 'react-toast/src/ToastProvider'

const components = {
  Toast,
  ToastContainer,
}

export function ToastProvider(props: { children: React.ReactNode }) {
  return (
    <ToastProviderOriginal components={components} placement="top-center" autoDismissTimeout={3000}>
      {props.children}
    </ToastProviderOriginal>
  )
}

export default function Toast(props: ToastProps) {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 570px;
        height: 45px;
        box-sizing: border-box;
        border-radius: 2px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.35);
        padding: 0 15px;
        color: ${Colors.White};
        opacity: ${props.transitionState === 'entered' ? 1 : 0};
        transform: ${props.transitionState === 'entered'
          ? 'translate(0, 0)'
          : 'translate(0, -45px)'};
        transition: all ${props.transitionDuration}ms;
        background-color: ${props.appearance === 'error' ? Colors.Red400 : Colors.Green400};
      `}
    >
      <div>
        {props.appearance === 'error' ? (
          <WarningIcon css={iconMarginStyle} />
        ) : (
          <CheckmarkIcon css={iconMarginStyle} />
        )}

        {props.children}
      </div>

      <button
        css={css`
          background: none;
          border: none;
          color: ${Colors.White};
          padding: 0;
        `}
        onClick={() => props.onDismiss()}
      >
        <CloseIcon />
      </button>
    </div>
  )
}

const iconMarginStyle = css`
  margin-right: 5px;
`
